export const Accordion = (target: HTMLDivElement) => {
  const el = {
    root: target,
    trigger: target.querySelector<HTMLLabelElement>('.accordion__trigger'),
    dropdown: target.querySelector<HTMLDivElement>('.accordion__dropdown'),
    input: target.querySelector<HTMLInputElement>('.accordion__input'),
  }

  const method = {
    init: () => {
      if (!el.trigger) return
      if (el.input) el.input.addEventListener('change', method.onChange)
      if (!el.input) el.trigger.addEventListener('click', method.onChange)
      if (el.root.classList.contains('accordion--selected')) method.openDropdown()

      if (el.dropdown) {
        window.addEventListener('resize', () => {
          if (!el.dropdown) return
          if (!el.root.classList.contains('accordion--selected')) return
          el.dropdown.style.maxHeight = `${el.dropdown.scrollHeight}px`
        })
      }
    },

    onChange: () => {
      if (el.root.classList.contains('accordion--selected')) {
        el.root.classList.remove('accordion--selected')
        if (el.dropdown) el.dropdown.style.maxHeight = '0'
        return
      }

      if (el.input) {
        method.resizeParent()
        method.resetAccordions()
      }

      method.openDropdown()
    },

    resetAccordions: () => {
      const radioGroup = el.root.parentElement as HTMLElement
      if (!radioGroup || !radioGroup.classList.contains('radio-group')) return

      const selectedRadios =
        radioGroup.querySelectorAll<HTMLDivElement>('.accordion--selected')
      selectedRadios.forEach((item) => {
        const dropdown = item.querySelector<HTMLDivElement>('.accordion__dropdown')
        item.classList.remove('accordion--selected')
        if (dropdown) dropdown.style.maxHeight = '0'
      })
    },

    resizeParent: () => {
      const parentRadioCard = el.root.closest('.radio-card')
      if (!parentRadioCard) return

      const parentDropdown = parentRadioCard.querySelector<HTMLDivElement>(
        '.radio-card__dropdown'
      )
      if (!parentDropdown) return

      const activeDropdown = parentRadioCard.querySelector<HTMLDivElement>(
        '.accordion--selected .accordion__dropdown'
      )
      if (!activeDropdown) return

      const heightDifference = Math.abs(
        activeDropdown.clientHeight - el.dropdown.scrollHeight
      )
      const newParentDropdownHeight = `${
        parentDropdown.clientHeight + heightDifference
      }px`
      parentDropdown.style.maxHeight = newParentDropdownHeight
    },

    openDropdown: () => {
      el.root.classList.add('accordion--selected')
      if (el.dropdown) {
        el.dropdown.style.maxHeight = `${el.dropdown.scrollHeight}px`
      }
    },
  }

  method.init()
}
